import { createApp } from 'vue';
import UpdateAvailable from './UpdateAvailable.vue';

export function initUpdateAvailable(): void {
  if (document.getElementById('jidoka-update-root')) return;
  const root = document.createElement('div');
  root.id = 'jidoka-update-root';
  document.body.appendChild(root);
  createApp(UpdateAvailable).mount(root);
}
